import { useSite } from "@/context/SiteContext";

function Legal({ title, contentKey }) {
  const { settings } = useSite();
  const text = settings?.[contentKey] || "";
  return (
    <main className="bg-ivory text-ink pt-32 md:pt-40 pb-32 px-6 md:px-12 lg:px-16 min-h-screen">
      <p className="label-mono opacity-60 line-badge">Legal</p>
      <h1 className="mt-8 font-editorial text-5xl md:text-7xl leading-[0.95]">{title}</h1>
      <div className="mt-12 max-w-3xl text-lg text-ink/80 leading-relaxed whitespace-pre-wrap">
        {text || "Content coming soon."}
      </div>
    </main>
  );
}

export function Privacy() {
  return <Legal title="Privacy Policy" contentKey="privacy_policy" />;
}

export function Terms() {
  return <Legal title="Terms & Conditions" contentKey="terms_conditions" />;
}

export function NotFound() {
  return (
    <main className="bg-ink text-ivory min-h-screen flex items-center justify-center px-6 text-center" data-testid="not-found">
      <div>
        <p className="label-mono opacity-60">404</p>
        <h1 className="font-editorial text-7xl md:text-9xl italic mt-6">Not here.</h1>
        <p className="mt-6 opacity-80 max-w-md mx-auto">This page has moved or does not exist yet.</p>
        <a href="/" className="btn-outline-ivory mt-10 inline-flex">Home</a>
      </div>
    </main>
  );
}
